$(document).ready(function(){
    var firstFilter = $('facets-form .accordion-list accordion-disclosure:first-child .accordion__disclosure');
    firstFilter.attr('aria-expanded', 'true').attr('open', '');
    
    // PRODUCT ADDITIONAL CHECKOUT BUTTON

    $('.chk_btn_additional').click(function(e){         
    e.preventDefault();
        var var_id = $(this).parents('form').find('input[name="id"]').val();
        // var qty = $(this).parents('form').find('.ProductForm__Variants input[name="quantity"]').val();
        
        console.log(var_id);
           // console.log(qty);

        $.ajax({

            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: var_id
            },
            dataType: 'json', 
            success: function (data) { 
                window.location.href="/checkout";
            },
            error: function (data) { 
                window.location.href="/checkout";
            }
        });

    });

    $(document).on('click', '.Product__ActionItem .RoundButton', function(){
        $(this).toggleClass('is-active');
        $(this).next().toggleClass('Product__ShareList_show');
    });

})